import { ApiUrls } from "./api-urls";
import { HttpService } from "./application.service"
import { SessionService } from "./session.service";

export const AuthenticationService = {
    login: (data: any) => {
        return HttpService.post<any>(ApiUrls.LOGIN, data);
    },
    registration: (data: any) => {
        return HttpService.post<any>(ApiUrls.REGISTRATION, data);
    },
    logout:()=>{
        SessionService.reset(); 
    }
}